import script from "./RegionDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegionDetail.vue?vue&type=script&lang=ts&setup=true"

import "./RegionDetail.vue?vue&type=style&index=0&id=410fd2eb&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-410fd2eb"]])

export default __exports__